<template>
  <a-modal v-if="modal" @close="$emit('close')">
    <h2 slot="header">
      Sigue estas instrucciones para subir adecuadamente la foto de tus
      documentos
    </h2>
    <div slot="body">
      <div class="intructions">
        <a-icon name="ic-help-toc-glight" />
        <p>
          Sitúa la cámara del dispositivo cerca de tu documento y asegúrate de
          que tengas una buena iluminación
        </p>
      </div>
      <div class="intructions">
        <a-icon name="ic-help-toc-blight" />
        <p>
          Evita el reflejo de luz al momento de tomar la foto
        </p>
      </div>
    </div>
    <div slot="footer"></div>
  </a-modal>
</template>

<script>
import AModal from '@/components/ui/AModal';
import AIcon from '@/components/ui/AIcon';

export default {
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AModal,
    AIcon,
  },
};
</script>

<style></style>
